<template>
  <div>
    <PageHeader :title="t('title')" />
    <SearchToolbar
      class="mb-6"
      :placeholder="t('search_placeholder')"
      :initial-keywords="keywords"
      @update-keyword-search="updateKeywordSearch"
    />
    <Loading v-if="loading" />
    <div v-else-if="users.length === 0" class="text-center mt-4 py-2">
      <p>{{ t("no_results") }}</p>
    </div>
    <div v-else>
      <Table :columns="columns" :data="users">
        <template #signedUp="{ row }">
          <FieldSpan
            :style-to-add="row.signedUp ? 'text-green-800 bg-green-200' : 'text-red-800 bg-red-200'"
            :value="row.signedUp ? t('signed_up_yes') : t('signed_up_no')"
          />
        </template>
      </Table>
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        :totalCount="totalCount"
        @changePage="handleChangePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { useI18n } from "vue-i18n";
import { PageHeader, Loading, Table, Pagination, FieldSpan, SearchToolbar } from "@estaly/ui";

export default {
  components: { PageHeader, Loading, Table, Pagination, FieldSpan, SearchToolbar },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      loading: true,
      keywords: null,
      columns: [],
    };
  },

  computed: {
    ...mapState("merchantProfiles", {
      users: "index",
      currentPage: "currentPage",
      totalPages: "totalPages",
      totalCount: "totalCount",
    }),
  },

  async created() {
    this.buildColumns();
    await this.retrieveUsers();
  },

  methods: {
    ...mapActions("merchantProfiles", { fetchUsers: "fetchIndex" }),

    buildColumns() {
      this.columns = [
        { label: this.t("column_id"), field: "id", widthClass: "w-16" },
        { label: this.t("column_email"), field: "email" },
        { label: this.t("column_full_name"), field: "fullName" },
        { label: this.t("column_role"), field: "translatedRole" },
        { label: this.t("column_signed_up"), field: "signedUp", slot: "signedUp" },
      ];
    },

    async retrieveUsers(page = 1) {
      this.loading = true;
      let response;
      try {
        response = await this.fetchUsers({ page, keywords: this.keywords });
      } catch (error) {
        console.error(error);
      } finally {
        // An outdated response must not stop the loader of the request still pending.
        if (response?.isLatest !== false) this.loading = false;
      }
    },

    handleChangePage(page) {
      this.retrieveUsers(page);
    },

    updateKeywordSearch(keywords) {
      this.keywords = keywords;
      this.retrieveUsers();
    },
  },
};
</script>

<i18n src="./UserList.i18n.json"></i18n>
